import React from 'react';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  alignItemsBaseline,
  colors,
  DEFAULT_GUTTER,
  flexCenter,
  SEARCH_LARGE_BREAKPOINT,
  SEARCH_XLARGE_BREAKPOINT,
  SPACE_COMPACT,
  SPACE_MINIMUM,
  spaceGapMinimum,
} from '@/styles';
import { FCC } from '@/utils/types';

import { SkeletonBlock } from './skeleton';

const numberStyles = css`
  display: flex;
  align-items: baseline;
  color: ${token('color.text', colors.N800)};
  font-weight: 400;
  font-size: 2rem;
  min-width: 6.25rem;
  white-space: nowrap;
  @media screen and (min-width: ${SEARCH_LARGE_BREAKPOINT}px) {
    font-size: 1.5rem;
  }
  @media screen and (min-width: ${SEARCH_XLARGE_BREAKPOINT + DEFAULT_GUTTER * 4}px) {
    font-size: 2rem;
  }
`;

const percentageStyles = css`
  font-size: 1.2rem;
  color: ${token('color.text.subtlest', colors.N70)};
  margin-left: ${SPACE_COMPACT}px;
`;

const fractionStyles = css`
  font-size: 1.2rem;
  color: ${token('color.text.subtlest', colors.N70)};
  margin-left: ${SPACE_MINIMUM}px;
  ${flexCenter};
  ${alignItemsBaseline};
  ${spaceGapMinimum};
`;

export type HeroNumberProps = {
  isSkeleton?: boolean;
  isFraction?: boolean;
  isUnitHidden?: boolean;
  appendix?: React.ReactNode;
};

const HeroNumber: FCC<HeroNumberProps> = ({
  isSkeleton,
  isFraction,
  isUnitHidden,
  appendix,
  children,
  ...other
}) =>
  !isSkeleton ? (
    <h4 css={numberStyles} {...other}>
      {children}
      {isUnitHidden ? (
        ''
      ) : (
        <>
          {isFraction ? (
            <span css={fractionStyles}>
              <img alt="/" src="/static/slash.svg" />
              <span>10</span>
            </span>
          ) : (
            <span css={percentageStyles}>%</span>
          )}
          {appendix && <>{appendix}</>}
        </>
      )}
    </h4>
  ) : (
    <SkeletonBlock width={110} />
  );

export default HeroNumber;
